export default "__VITE_ASSET__BTuc2EH6__"